import { defineStore } from 'pinia'

export const useLayoutStore = defineStore('Layout', {
  state: () => ({
    marginBottom: 0,
    imagemCarrosselAltura: 0,
    imagemMapaAltura: 0,
    latitudeMapaObra: 0,
    longitudeMapaObra: 0,
    deviceType: 'desktop'
  }),
  getters: {
    doubleCount: (state) => state.marginBottom * 2,
    getImagemAltura: (state) => state.imagemMapaAltura - state.imagemCarrosselAltura
  },
  actions: {
    setMarginBottomValue(marginBottom: number) {
      this.marginBottom = marginBottom
    },
    setImagemCarrosselAltura(imagemCarrosselAltura: number) {
      this.imagemCarrosselAltura = imagemCarrosselAltura
    },
    setImagemMapaAltura(imagemMapaAltura: number) {
      this.imagemMapaAltura = imagemMapaAltura
    },
    setLatitudeMapaObra(latitudeMapaObra: number) {
      this.latitudeMapaObra = latitudeMapaObra
    },
    setLongitudeMapaObra(longitudeMapaObra: number) {
      this.longitudeMapaObra = longitudeMapaObra
    },
    setDeviceType(type: string) {
      this.deviceType = type;
    }
  }
})
